/*eslint-disable */
import axios from 'axios';
import root from '../_helpers/roots';
let dataUrl = root.publicCourseCategory.link;
let courseDesciptionUrl = root.publicCourseRead.link
let pubCoursesPdfLinkUrl = root.pubCoursesPdfLink.link
let publicLeaderboardURL = root.publicLeaderboardUrl.link

export default {
  state: {
    courseCategory: {},
    categoryList: {},
    courseDetail: {},
    publicLeaderboardState:{}
  },
  mutations: {
    setCourseCategory(state, value) {
      state.courseCategory = value;
      //    debugger;
    },
    setCategoryList(state, value) {
      state.categoryList = value
    },
    setCourseDetail(state, value) {
      state.courseDetail = value;
    },
    publicLeaderboardMutations(state, value) {
      state.publicLeaderboardState = value;
    }
  },
  actions: {
    getPublicLeaderboardListFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(publicLeaderboardURL)
          .then(function(response) {
            context.commit('publicLeaderboardMutations', response.data);
            resolve(response.data);
          })
          .catch(
            function(err) {
              reject(err);
            }
          )
      })
    },
    getCourseCategory(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(dataUrl)
          .then(function(response) {
            context.commit('setCourseCategory', response.data);
            resolve(response.data);
          })
          .catch(
            function(err) {
              reject(err);
            }
          )
      })
    },
    getCourseList(context, payload) {
      let courseListUrl = dataUrl + payload.id + '/';
      return new Promise((resolve, reject) => {
        axios.get(courseListUrl)
          .then(function(response) {
            context.commit('setCategoryList', response.data);
            resolve(response.data);
          })
          .catch(
            function(err) {
              reject(err);
            }
          )
      })
    },
    getCourseDetail(context, payload) {
      let courseReadUrl = courseDesciptionUrl + payload.id + '/';
      return new Promise((resolve, reject) => {
        axios.get(courseReadUrl)
          .then(function(response) {
            //    debugger;
            context.commit('setCourseDetail', response.data);
            resolve(response.data);
          })
          .catch(
            function(err) {
              //    debugger;
              reject(err);
            }
          )
      })
    },
    getPubCourseDetailPdf(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(pubCoursesPdfLinkUrl + payload.slug + '/')
          .then(function(response) {
            resolve(response.data);
          })
          .catch(
            function(err) {
              reject(err);
            }
          )
      })
    }
  },
  getters: {
    getCourseCategoryGetter: state => state.courseCategory,
    getCourseListGetter: state => state.categoryList,
    getCourseDetail: state => state.courseDetail,
    publicLeaderboardGetters: state => state.publicLeaderboardState
  }
}